const components = document.getElementsByClassName('c-tabbed-content');

const isChildOf = (e, className) => {
   const parentNodes = e.composedPath();

   return parentNodes.filter(parent => { 
      return parent.classList && parent.classList.contains(className);
   }).length;
}

if( components.length ) {

   Array.from(components).forEach( (component) => {

      component.addEventListener('click', (e) => {
         const target = e.target;
         
         // Prevent default if the click is outside the content (dont block links etc)
         if( !isChildOf(e, 'c-tabbed-content__content') ) {
            e.preventDefault();
         }

         // Tab buttons
         if( target.classList.contains('js-tabbed-content__tab') ) {

            // All of the tabs on this component
            const tabs = component.querySelectorAll('.js-tabbed-content__tab');

            // Remove the active styling from all the tabs
            Array.from(tabs).forEach((tab) => {
               tab.classList.remove('text-white');
               tab.classList.remove('bg-primary');
               tab.classList.add('text-black');
               tab.classList.add('bg-lightblue');
            });

            // Add active styling
            target.classList.add('text-white');
            target.classList.add('bg-primary');
            target.classList.remove('text-black');
            target.classList.remove('bg-lightblue');

            // Fetch all of the content areas
            const tabContents = component.querySelectorAll('.c-tabbed-content__content');

            // Find the target content area
            const tabId = target.dataset.tabId;
            const targetContents = document.getElementById(tabId);

            if( targetContents ) {

               // Hide all content areas inside this component
               Array.from(tabContents).forEach((el) => {
                  el.classList.add('hidden');
               })
               
               // Show it
               targetContents.classList.remove('hidden');

            }
         }

      })

   });



}
